export default "__VITE_ASSET__D51_0wxG__"